<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <dl class="row">
    <div class="container">
      <div class="dialog-title">New Hunt</div>
      <div class="dialog-subtitle">Analyze hunt packages in a single hunt.</div>
      <hyperkit-error *ngIf="error" [error]="error"></hyperkit-error>
      <cyborg-notification
        class="scroll"
        *ngIf="checkWarnings && warnings.length > 0"
        color="warning"
      >
        The following field mappings categories and fields are missing:<br />
        <span *ngFor="let env of warnings; last as lastEnv">
          <em>{{ env.envName }}</em
          ><br />
          <span class="indent" *ngFor="let tool of env.tools; last as lastTool"
            ><em>{{ tool.toolName }}</em>
            <div class="double-indent">
              <strong *ngIf="tool.missingCategories.length > 0"
                >Missing field mapping(s):
              </strong>
              <span
                *ngFor="let category of tool.missingCategories; last as isLast"
                >{{ category }}<span *ngIf="!isLast">, </span>
              </span>
            </div>
            <div class="double-indent">
              <strong *ngIf="tool.missingFields.length > 0"
                >Missing field(s):
              </strong>
              <span *ngFor="let field of tool.missingFields; last as lastField"
                ><em>{{ field.category }}</em> -
                <span *ngFor="let name of field.fields; last as lastName">
                  {{ name }}<span *ngIf="!lastName">, </span></span
                ><br *ngIf="!lastField"
              /></span>
            </div>
          </span>
          <br *ngIf="!lastEnv"
        /></span>
        <span
          ><br />This will affect your hunt content. Finish environment
          configuration
          <a class="cursor" (click)="goToSettings()"><u>here</u></a> for full
          compatibility.</span
        >
        </cyborg-notification>
      <form
        class="k-form"
        [formGroup]="formGroup"
        autocomplete="off"
      >
        <hyperkit-input
        class="hyperkit-component" 
        type="text" 
        id="name"
        label="Name"
        formControlName="name">
      </hyperkit-input>
      <hyperkit-multiselect
      label="Environments"
      [options]="environments"
      displayProperty="name"
      formControlName="environments"
      valueProperty="id"
      (selectionChange)="onValueChange($event)"
      >
      </hyperkit-multiselect>
          <hyperkit-select
          label="Priority"
          [options]="priorities"
          formControlName="priority"
          ></hyperkit-select>
          <hyperkit-select
          label="Assignee"
          [displayProperty]="'fullName'"
          [valueProperty]="'id'"
          [options]="assignees$ | async"
          formControlName="assignee"
          ></hyperkit-select>
        <hyperkit-button
          size="medium"
          type="submit"
          [disabled]="!formGroup.valid"
          (click)="onSubmit()"
          text="Save"
        >
        </hyperkit-button>
      </form>
    </div>
  </dl>
</div>
